package com.ijoin.data.model

import com.ijoin.data.model.serialization.InstantIso8601Serializer
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class Ticket(
    val id: String,
    val userId: String,
    val eventId: String,
    val bookingId: String? = null,
    val eventTitle: String? = null,
    val eventLocation: String? = null,
    @Serializable(with = InstantIso8601Serializer::class)
    val eventDate: Instant? = null,
    val eventTimeZone: String? = null,
    @Serializable(with = InstantIso8601Serializer::class)
    val occurrenceDateTime: Instant? = null,
    val ticketNumber: String,
    val qrCode: String,
    val priceTierName: String? = null,
    val paidPrice: Double? = null,
    val holderName: String? = null,
    val holderEmail: String? = null,
    val status: TicketStatus,
    val validated: Boolean = false,
    @Serializable(with = InstantIso8601Serializer::class)
    val validatedAt: Instant? = null,
    val favorite: Boolean = false,
    @Serializable(with = InstantIso8601Serializer::class)
    val createdAt: Instant? = null
)

@Serializable
enum class TicketStatus {
    ACTIVE,
    CANCELLED,
    REFUNDED,
    USED
}
